<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                    </div>
                </div>

                      <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <mat-toolbar class="botones-adm">

                    <button mat-flat-button (click)="dialogCabecera(1,null)"
                        color="accent">{{Etiquetas.BotonACabecera}}</button>
                </mat-toolbar>
            </div>

        </div>
    </div>
</div>

<div class="container-custom-content">

    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                <mat-form-field color="accent-darker" appearance="standard">
                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                    <input matInput (keyup)="applyFilterCabeceras($event)" #input>
                </mat-form-field>
                <div class="mat-table-listas-precios-cabeceras">
                    <table mat-table matTableResponsive [dataSource]="dataSourceCabeceras" matSort
                        #matSortCabeceras="matSort" matSortActive="descripcion" matSortDirection="asc">

                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Cabeceras.Headers.Acciones}} </th>
                            <td mat-cell *matCellDef="let cab">
                                <div>


                                    <button matTooltip="Ver ítems de esta lista de precios" mat-icon-button
                                        (click)="seleccionarCabecera(cab)" color="primary-darker">
                                        <mat-icon color="accent-darker">arrow_circle_right</mat-icon>
                                    </button>

                                    <button matTooltip="{{Tooltips.Editar}}" (click)="dialogCabecera(2,cab)"
                                        mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">edit</mat-icon>
                                    </button>

                                    <button matTooltip="{{Tooltips.Eliminar}}" (click)="eliminarCabecera(cab)"
                                        mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">delete</mat-icon>
                                    </button>

                                </div>

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="idCompania">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Cabeceras.Headers.IdCompania}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                {{cab.idCompania}} </td>
                        </ng-container>
                        <ng-container matColumnDef="idSalesOrg">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Cabeceras.Headers.IdSalesOrg}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                {{cab.idSalesOrg}} </td>
                        </ng-container>

                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Cabeceras.Headers.Id}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                {{cab.id}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="descripcion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Cabeceras.Headers.Descripcion}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                {{cab.descripcion}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="formaPago">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Cabeceras.Headers.FormaPago}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                {{cab.formaPago}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="terminoPago">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Cabeceras.Headers.TerminoPago}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                {{cab.terminoPago}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="fechaValidaDesde">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Cabeceras.Headers.FechaValidaDesde}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                {{cab.fechaValidaDesde | date:'dd/MM/yyyy'}} </td>
                        </ng-container>


                        <ng-container matColumnDef="fechaValidaHasta">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Cabeceras.Headers.FechaValidaHasta}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                {{cab.fechaValidaHasta | date:'dd/MM/yyyy'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="descuentoDiscrecional">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Cabeceras.Headers.DescuentoDiscrecional}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                <div>
                                    <mat-icon color="accent-darker">{{ cab.descuentoDiscrecional ?
                                        'check_box' :
                                        'check_box_outline_blank' }}
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="precioFijo">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Cabeceras.Headers.PrecioFijo}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                <div>
                                    <mat-icon color="accent-darker">{{ cab.precioFijo ?
                                        'check_box' :
                                        'check_box_outline_blank' }}
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="habilitacion">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Cabeceras.Headers.Habilitacion}}
                            </th>
                            <td mat-cell *matCellDef="let cab">
                                <div>
                                    <mat-icon color="accent-darker">{{ cab.habilitacion ?
                                        'check_box' :
                                        'check_box_outline_blank' }}
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsCabeceras"></tr>
                        <tr mat-row *matRowDef="let cab; columns: displayedColumnsCabeceras;">
                        </tr>


                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumnsCabeceras.length">
                                {{Etiquetas.SinRegistros}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator #matPaginatorCabeceras="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>

        </div>

    </div>


    <div class="container-fluid" [hidden]="cabSeleccionada == null">



        <div class="mat-toolbar-custom">
            <mat-toolbar>
                <mat-toolbar-row [ngClass]="isMobileXL() ? 'mt-1 mb-1' : ''">
                    <div class="container-fluid">
                        <div class="d-flex align-items-baseline justify-content-between ">
                            <div>

                                <p *ngIf="cabSeleccionada != null" class="p-fecha">Lista de precio:
                                    {{cabSeleccionada.descripcion}}
                                </p>
                            </div>
                            <div>

                                <p *ngIf="cabSeleccionada != null" class="p-fecha">Termino Pago:
                                    {{cabSeleccionada.terminoPago}}
                                </p>
                            </div>
                        </div>
                    </div>

                </mat-toolbar-row>
                <mat-toolbar-row [ngClass]="isMobileXL() ? 'mt-1 mb-1' : ''">
                    <button mat-flat-button color="accent" (click)="exportarExcel()">
                        <mat-icon>download</mat-icon>
                        Exportar a excel
                    </button>

                    <span class="mat-toolbar-row-separador"></span>

                </mat-toolbar-row>



            </mat-toolbar>
        </div>

        <!-- <div class="mat-toolbar-custom">
            <mat-toolbar>

              

            </mat-toolbar>

        </div> -->

        <div class="mt-3 mb-1" [hidden]="!dataSourceItems.data.length">



            <div class="container-fluid">
                <div class="row align-items-center justify-content-evenly">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                        <mat-form-field color="accent-darker" appearance="standard">
                            <mat-label>{{Etiquetas.Buscar}}</mat-label>
                            <input matInput (keyup)="applyFilterItems($event)" #input>
                        </mat-form-field>
                        <div class="mat-table-listas-precios-items">
                            <table mat-table matTableResponsive [dataSource]="dataSourceItems" matSort
                                #matSortItems="matSort" matSortActive="descripcion" matSortDirection="asc">

                                <ng-container matColumnDef="acciones">
                                    <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Items.Headers.Acciones}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        <div>

                                            <button matTooltip="{{Tooltips.Editar}}" (click)="dialogItem(2,item)"
                                                mat-icon-button color="primary-darker">
                                                <mat-icon color="accent-darker">edit</mat-icon>
                                            </button>

                                            <button matTooltip="{{Tooltips.Eliminar}}" (click)="eliminarItem(item)"
                                                mat-icon-button color="primary-darker">
                                                <mat-icon color="accent-darker">delete</mat-icon>
                                            </button>

                                        </div>

                                    </td>
                                </ng-container>


                                <ng-container matColumnDef="idProducto">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Items.Headers.Id}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        {{item.idProducto}}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="descripcion">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Items.Headers.Descripcion}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        {{item.descripcion}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="idMoneda">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Items.Headers.IdMoneda}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        {{item.idMoneda}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="tasa">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Items.Headers.Tasa}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        {{item.tasa | number : '1.3-3'}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="idUnidadCondicion">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Items.Headers.IdUnidadMedidaBase}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        {{item.idUnidadCondicion}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="lineaProducto">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Items.Headers.LineaProducto}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        {{item.lineaProducto}}
                                    </td>
                                </ng-container>




                                <ng-container matColumnDef="fechaValidaDesde">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Items.Headers.FechaValidaDesde}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        {{item.fechaValidaDesde | date:'dd/MM/yyyy'}} </td>
                                </ng-container>


                                <ng-container matColumnDef="fechaValidaHasta">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Items.Headers.FechaValidaHasta}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        {{item.fechaValidaHasta | date:'dd/MM/yyyy'}} </td>
                                </ng-container>



                                <ng-container matColumnDef="habilitacion">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{Etiquetas.Items.Headers.Habilitacion}}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                        <div>
                                            <mat-icon color="accent-darker">{{ item.habilitacion ?
                                                'check_box' :
                                                'check_box_outline_blank' }}
                                            </mat-icon>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsItems"></tr>
                                <tr mat-row *matRowDef="let item; columns: displayedColumnsItems;">
                                </tr>


                                <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                    <td class="mat-cell" [attr.colspan]="displayedColumnsItems.length">
                                        {{Etiquetas.SinRegistros}}
                                    </td>
                                </tr>
                            </table>

                            <mat-paginator #matPaginatorItems="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                                showFirstLastButtons>
                            </mat-paginator>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</div>